export default __webpack_public_path__ + "static/media/item_2@2x.822e3e57.webp";